'use client';

import { useEffect, useState } from 'react';

/**
 * Hook to get a reference to the main content area element.
 * Returns the main DOM element if it exists.
 */
export function useMainContentRef() {
  const [mainElement, setMainElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    // Find the main element on the page
    const main = document.querySelector('main');
    if (main) {
      setMainElement(main);
    }
  }, []);

  return mainElement;
}
